export function updateMenusState(state, payload) {
  state[payload.state] = payload.data;
}
